export default __webpack_public_path__ + "static/media/aggrement_desktop.17992486.png";